export function getGraphQLField<T extends object, K extends keyof T & string>(
  data: T | null | undefined,
  fieldName: K
): T[K] {
  if (
    data == null ||
    typeof data !== 'object' ||
    Array.isArray(data) ||
    !Object.hasOwn(data, fieldName) ||
    data[fieldName] === undefined
  ) {
    throw new Error(`GraphQL response is missing field "${fieldName}".`);
  }

  return data[fieldName];
}
